import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  isPaid?: boolean
  fullName: string
  tickerReceipt?: string
  qrCode?: string
  listNames: {
    label: string
    value: string
  }[]
}

export const PassengerItem = ({ qrCode, fullName, listNames }: Props) => {
  return (
    <div className={s.container}>
      <span className={clsx(s.title, 'medium-15')}>{fullName}</span>

      {listNames?.map((item) => (
        <div className={s.item}>
          <span className={clsx(s.label, 'regular-12')}>{item?.label}</span>
          <span className={clsx(s.text, 'regular-14')}>{item?.value}</span>
        </div>
      ))}

      {Boolean(qrCode?.length) && (
        <img
          className={s.qrCode}
          src={`data:image/png;base64,${qrCode}`}
        />
      )}
    </div>
  )
}
